import React, { useEffect, useState, useCallback } from "react";
import {
  Button,
  Filter,
  FilterValue,
  TableTR,
  Table,
} from "../../../components";
import { Avatar } from "@/utils/ui/Avatar/Avatar";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../../../store";
import {
  UserReject,
  UserApprove,
  getListUserBunch,
} from "@/store/user/user.action";
import AddUserForm from "@/components/UserPages/AddUser";
import Modal from "@/components/Modal/Modal";
import { AlertDialog } from "@/utils/ui/AlertDialog/AlertDialog";
import { userStatusToTextAndColor } from "../../../utils";
import PageHeader from "@/components/Layout/PageHeader";
import { formatTimestampToAgo } from "../../../utils";
import { getListUser } from "@/store/user/user.action";
import { Eye, Edit } from "lucide-react";
import { NoContentFound } from "@/utils/ui/NoContent";
// import NoContentFound from "@/utils/ui/NoContent/NoContent";

import { useParams, useNavigate } from "react-router-dom";
const headers: { name: string; width: string }[] = [
  { name: "Name", width: "25%" },
  { name: "Date", width: "15%" },
  { name: "Email", width: "10%" },
  { name: "Business", width: "15%" },
  { name: "Team/Property", width: "15%" },
  { name: "Status", width: "10%" },
  { name: "Action", width: "10%" },
];

const UserList = ({
  bunchBusinessList,
  bunchProductList,
  usercount,
  getListUser,
  users,
  loading,
  getListUserBunch,
}: Props) => {
  const { userId } = useParams<{ userId?: string }>();
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string>("");
  const [modalContent, setModalContent] = useState<React.ReactNode | null>(
    null
  );
  const [filters, setFilters] = useState<Record<string, FilterValue>>({});
  const [availableFilters, setAvailableFilters] = useState<Filter[]>([]);
  const [submitAddUser, setSubmitAddUser] = useState<(() => void) | null>(null);
  const [isView, setIsView] = useState<boolean>(false);
  const [isConfirmModalOpen, setConfirmModalOpen] = useState<boolean>(false);
  const [editUser, setEditUser] = useState<boolean>(false);
  const [hiddenFilters, setHiddenFilters] = useState<any>({
    foreign_keys: ["session"],
  });
  const [isAddUserDisabled, setIsAddUserDisabled] = useState<boolean>(false);

  const [autoselectUser, setAutoselectUser] = useState<any[]>([]);

  const handleSetFilters = (filters: Record<string, FilterValue>) => {
    setFilters(filters);
  };

  useEffect(() => {
    if (
      bunchBusinessList?.length === 0 ||
      bunchProductList?.length === 0 ||
      availableFilters.length > 0
    )
      return;
    const usersConstOptionArray = autoselectUser?.map((value: any) => ({
      label: value?.name,
      value: value?.id,
      displayValue: value?.name,
    }));

    setAvailableFilters([
      {
        displayName: "Email",
        name: "email",
        type: "text",
        suffix: "contains",
      },
      {
        displayName: "Keyword",
        name: "name",
        type: "text",
        suffix: "contains",
      },
      {
        displayName: "Name",
        name: "id",
        type: "autoselect",
        suffix: "contains",
        options: usersConstOptionArray,
      },
      {
        displayName: "Business",
        name: "business",
        type: "multiselect",
        suffix: ":",
        options: bunchBusinessList?.map((business: any) => ({
          label: business?.name,
          value: business?.id,
        })),
      },
      {
        displayName: "team",
        name: "team",
        type: "multiselect",
        suffix: ":",
        options: bunchProductList?.map((product: any) => ({
          label: product?.name,
          value: product?.id,
        })),
      },
    ]);
  }, [bunchBusinessList, bunchProductList, availableFilters.length]);

  const normalizeValue = (value: string | string[]): string[] => {
    if (Array.isArray(value)) {
      return value;
    }
    return [value];
  };

  const handleCreateUser = () => {
    if (submitAddUser) submitAddUser();
    const event = new Event("createUser");
    window.dispatchEvent(event);
  };

  const handleApproveUser = () => {
    if (submitAddUser) submitAddUser();
    const event = new Event("approveUser");
    window.dispatchEvent(event);
  };

  const handleRejectUser = () => {
    setConfirmModalOpen(false);
    if (submitAddUser) submitAddUser();
    const event = new Event("rejectUser");
    window.dispatchEvent(event);
  };

  const handleModalClose = useCallback(() => {
    setModalTitle("");
    setModalContent(null);
    setIsModalOpen(false);

    navigate("/users", { replace: true });
  }, [navigate]);

  const handleModalOpen = useCallback(
    (isEdit?: boolean, item?: any, isView?: boolean) => {
      setEditUser(isEdit ?? false);
      setIsView(isView ?? false);
      setIsModalOpen(true);
      setModalContent(
        <AddUserForm
          onClose={handleModalClose}
          registerSubmit={setSubmitAddUser}
          isEdit={isEdit}
          item={item}
          setIsAddUserDisabled={setIsAddUserDisabled}
          isView={isView}
          getListUser={getListUser}
          setFilters={setFilters}
        />
      );
      setModalTitle(isEdit ? "Edit User" : "Add User");
      if (item?.id) {
        navigate(`/users/${item.id}`, { replace: true });
      } else {
        navigate("/users/add", { replace: true });
      }
    },
    [navigate, getListUser, handleModalClose]
  );

  useEffect(() => {
    if (userId && users.length > 0) {
      const user = users.find((u: any) => u.id === userId);
      if (user) {
        const isView = user.status === 0;
        const isEdit = user.status !== 0 && user.status !== 3;
        handleModalOpen(isEdit, user, isView);
      }
    } else if (userId === "add") {
      handleModalOpen(false);
    }
  }, [userId, users, handleModalOpen]);

  return (
    <div className="container">
      <PageHeader
        title="USERS"
        buttonText="ADD NEW"
        onButtonClick={() => handleModalOpen(false)}
        backPath="/setting"
      />
      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onClose={handleModalClose}
          title={modalTitle}
          width="90vw"
          footer={
            isView === false ? (
              <div className="d-flex justify-content-end">
                <Button
                  className="text-white"
                  isDisabled={isAddUserDisabled}
                  onClick={handleCreateUser}
                >
                  {editUser ? "UPDATE USER" : "CREATE USER"}
                </Button>
              </div>
            ) : (
              <div className="d-flex gap-4">
                <Button
                  className="text-white bg-danger border-danger"
                  onClick={() => setConfirmModalOpen(true)}
                >
                  Reject User
                </Button>
                <Button className="text-white" onClick={handleApproveUser}>
                  Approve User
                </Button>
              </div>
            )
          }
        >
          {modalContent}
        </Modal>
      )}
      {isConfirmModalOpen && (
        <AlertDialog
          isOpen={isConfirmModalOpen}
          onClose={() => setConfirmModalOpen(false)}
          onConfirm={handleRejectUser}
          title="ALERT!"
          message="Are you sure you want to reject this user?"
          confirmText="Confirm"
          cancelText="Cancel"
          confirmButtonType="danger"
        />
      )}
      <Table
        columns={headers}
        isLoading={loading}
        totalCount={usercount}
        // onFilterChange={handleFilterChange}
        appliedFilters={filters}
        availableFilters={availableFilters}
        handleSetFilters={handleSetFilters}
        getListMedia={getListUser}
        filters={filters}
        hiddenFilters={hiddenFilters}
        setHiddenFilters={setHiddenFilters}
        isSetinParams={false}
        stopIfNoFilter={false}
        autoSelectLoader={true}
        onAutoSelectClose={() => {
          setAutoselectUser([]);
        }}
        onAutoSelectInputChange={(params) => {
          const keyword = (params.keyword || "").trim();
          if (keyword.length >= 3) {
            if (params.name === "id") {
              getListUserBunch({ name: keyword }).then((res: any) => {
                setAutoselectUser(res);
              });
            }
          } else {
            if (params.name === "id") {
              getListUserBunch({ name: "" }).then((res: any) => {
                setAutoselectUser([]);
              });
            }
          }
        }}
        autoSelectOptionsMap={{
          id: (() => {
            const userOptions = (autoselectUser || [])?.map((item: any) => ({
              label: item?.name,
              value: item?.id,
            }));

            return userOptions;
          })(),
        }}
      >
        {users.length > 0 ? (
          users.map((item: any) => (
            <TableTR key={item.id} rowKey={item.id}>
              <td>
                <div className="d-flex align-items-center gap-2">
                  <Avatar text={item.name} size={30} fontsize={15} />
                  <span>{item.name}</span>
                </div>
              </td>
              <td>{formatTimestampToAgo(item.ct)}</td>
              <td>{item.email}</td>
              <td>
                {bunchBusinessList?.find((b: any) =>
                  normalizeValue(b.id).includes(item.business)
                )?.name || item.business}
              </td>
              <td>
                {bunchProductList.find((p: any) =>
                  normalizeValue(p.id).includes(item.team)
                )?.name || item.team}
              </td>
              <td className="px-3">
                <span
                  className={`badge ${
                    item.status === 1 ? "bg-primary" : "bg-secondary"
                  }`}
                >
                  {userStatusToTextAndColor(item.status)}
                </span>
              </td>
              <td>
                <div className="px-2 py-1 d-flex align-items-center gap-2 flex-wrap">
                  {item.status === 0 ? (
                    <span
                      className="btn btn-outline-secondary"
                      title="View Request"
                      onClick={() => handleModalOpen(false, item, true)}
                    >
                      <Eye size={16} />
                    </span>
                  ) : (
                    item.status !== 3 && (
                      <span
                        className="btn btn-outline-secondary"
                        title="Edit"
                        onClick={() => handleModalOpen(true, item)}
                      >
                        <Edit size={16} />
                      </span>
                    )
                  )}
                </div>
              </td>
            </TableTR>
          ))
        ) : (
          <TableTR rowKey="no-content">
            <td colSpan={headers.length}>
              <NoContentFound message="No Users Found" fill />
            </td>
          </TableTR>
        )}
      </Table>
    </div>
  );
};

const mapState = (state: RootState) => ({
  userList: state.app.constUserList,
  usercount: state.users.userList.count,
  users: state.users.userList.list,
  bunchBusinessList: state.constants.bunchBusinessList.list,
  bunchProductList: state.constants.bunchProductList.list,
  loading: state.users.userList.isLoading,
});
const mapDispatch = {
  UserReject,
  UserApprove,
  getListUser,
  getListUserBunch,
};

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector>;
export default connector(UserList);
